import { BaseEntity } from '../base/base.entity';
import { AppService } from '../main/app.service';
import { BaseService } from '../base/base.service';

export class ITimezone {
    id?: any;
    from: any;
    till: any;
    percentage: number;
    amount: number;
    priority: number;
    dayOfWeek: number;
    fixedDate: boolean;
    fixedDateWithoutYear: boolean;
    salaryScaleGroupId: string;
    salaryScaleGroupName?: string;
}

export class TimezonesService extends BaseService<ITimezone> {
 
    constructor(protected Restangular: Restangular.IService, protected AppService: AppService) {
        "ngInject";
        super(Restangular, AppService, 'timezone');
    }
}


// WEBPACK FOOTER //
// ./src/app/services/timezone.service.ts